"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = void 0;

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

var mutations = {
  SET_LANGUAGE: function SET_LANGUAGE(state, langCode) {
    state.language = langCode;
  },
  SET_BREADCRUMB_LIST: function SET_BREADCRUMB_LIST(state, data) {
    state.breadcrumbList = data || [];
  },
  SET_LOADING: function SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_DARK_THEME: function SET_DARK_THEME(state, theme) {
    state.isDarkTheme = theme;
  },
  SET_IS_FULLSCREEN: function SET_IS_FULLSCREEN(state, data) {
    state.isFullscreen = data;
  },
  SET_IS_ORDER_FULLSCREEN: function SET_IS_ORDER_FULLSCREEN(state, data) {
    state.isOrderFullscreen = data;
  },
  SET_IS_MOBILE: function SET_IS_MOBILE(state, data) {
    state.isMobile = data;
  },
  SET_MAIN_CONTAINER_HEIGHT: function SET_MAIN_CONTAINER_HEIGHT(state, data) {
    state.mainContainerHeight = data;
  },
  SET_DASHBOARD_VEHICLES: function SET_DASHBOARD_VEHICLES(state, data) {
    state.dashboardVehicles = data || [];
  },
  ADD_DASHBOARD_VEHICLES: function ADD_DASHBOARD_VEHICLES(state, data) {
    state.dashboardVehicles.push(data);
  },
  REMOVE_DASHBOARD_VEHICLES: function REMOVE_DASHBOARD_VEHICLES(state, data) {
    state.dashboardVehicles = state.dashboardVehicles.filter(function (vehicle) {
      return vehicle['id'] !== data['id'];
    });
  },
  SET_IS_TAB: function SET_IS_TAB(state, istab) {
    state.isTab = istab;
  },
  SET_CORE_INFORMATION: function SET_CORE_INFORMATION(state, data) {
    var _data = (0, _slicedToArray2.default)(data, 4),
        drivers = _data[0],
        projectCodes = _data[1],
        customers = _data[2],
        trucks = _data[3];

    state.drivers = drivers && drivers['data'] ? drivers['data'] : [];
    state.projectCodes = projectCodes && projectCodes['data'] ? projectCodes['data'] : [];
    state.customers = customers && customers['data'] ? customers['data'] : [];
    state.trucks = trucks && trucks['data'] ? trucks['data'] : [];
  },
  SET_SOCKET_ID: function SET_SOCKET_ID(state, data) {
    state.socketId = data;
  }
};
exports.mutations = mutations;